import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Divider,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import BrandLogo from "./BrandLogo";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const navLinks = [
    { to: "/", key: "navHome" },
    { to: "/apps", key: "navApps" },
    { to: "/news", key: "navNews" },
    { to: "/contacts", key: "navContacts" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        mt: { xs: 8, md: 14 },
        pt: { xs: 6, md: 8 },
        pb: 4,
        position: "relative",
        bgcolor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <BrandLogo />
            <Typography color="text.secondary" sx={{ mt: 2, maxWidth: 360 }}>
              {t("footerTagline")}
            </Typography>
          </Grid>

          <Grid item xs={6} md={3}>
            <Typography variant="overline" color="text.secondary">
              {t("footerNav")}
            </Typography>
            <Stack spacing={1.2} sx={{ mt: 1.5 }}>
              {navLinks.map((l) => (
                <Link
                  key={l.to}
                  component={RouterLink}
                  to={l.to}
                  underline="none"
                  color="text.primary"
                  sx={{ "&:hover": { color: "primary.main" } }}
                >
                  {t(l.key)}
                </Link>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={6} md={4}>
            <Typography variant="overline" color="text.secondary">
              {t("footerContacts")}
            </Typography>
            <Stack spacing={1.4} sx={{ mt: 1.5 }}>
              <Stack direction="row" spacing={1.25} alignItems="center">
                <EmailRoundedIcon fontSize="small" color="primary" />
                <Link href="mailto:support@uramaks.com" underline="none" color="text.primary">
                  support@uramaks.com
                </Link>
              </Stack>
              <Stack direction="row" spacing={1.25} alignItems="center">
                <LanguageRoundedIcon fontSize="small" color="primary" />
                <Link href="https://uramaks.com" target="_blank" rel="noreferrer" underline="none" color="text.primary">
                  uramaks.com
                </Link>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
        >
          <Typography variant="body2" color="text.secondary">
            © {year} URAMAKS.com — {t("footerRights")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("footerCraft")}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
